{
  "on": "ein",
  "none": "Nein",
  "device": "Geräte | Gerät | Geräte",
  "operation": "Vorgänge | Vorgang | Vorgänge",
  "profile": "Profile | Profil | Profile",
  "application": "Anwendungen | Anwendung | Anwendungen",
  "campaign": "Kampagnen | Kampagne | Kampagnen",
  "user": "Benutzer | Benutzer | Benutzer",
  "group": "Gruppen | Gruppe | Gruppen",
  "userGroup": "Nutzergruppen | Nutzergruppe | Nutzergruppen",
  "firmware": "Firmware | Firmware | Firmware",
  "applicationMgt": "Anwendungen | Anwendung | Anwendungen",
  "dtwins": "Geräte | Gerät | Geräte"
}
